import { render } from "./Share.vue?vue&type=template&id=085c2574&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=085c2574&lang=less"
import "./Share.vue?vue&type=style&index=1&id=085c2574&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085c2574"]])

export default __exports__